<template>
  <v-row>
    <v-col v-for="n in 3" :key="n" cols="12">
      <v-card flat class="rounded-lg">
        <v-row class="ma-0">
          <v-col cols="5" sm="3" lg="2" class="text-start">
            <v-skeleton-loader
              height="80"
              max-height="100"
              type="image"
              class="rounded-lg"
            />
          </v-col>

          <v-col class="ps-0 align-self-center">
            <v-skeleton-loader height="12" type="text" class="mb-2" />

            <v-skeleton-loader height="12" type="text" class="mb-6" />

            <div class="d-flex flex-row justify-space-between">
              <v-skeleton-loader width="60" height="12" type="text" />

              <v-skeleton-loader width="20" height="12" type="text" />
            </div>
          </v-col>

          <template v-if="$vuetify.breakpoint.smAndUp">
            <v-col cols="2" class="align-self-center justify-center">
              <v-skeleton-loader height="12" type="text" />
            </v-col>

            <v-col cols="2" class="align-self-center justify-center">
              <v-skeleton-loader height="12" type="text" />
            </v-col>

            <v-col cols="2" class="align-self-center justify-center">
              <v-skeleton-loader height="12" type="text" />
            </v-col>
          </template>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {};
</script>
